export const FETCH_SUBSCRIBER_DETAILS = '/packetsSubscription/details';

export const POST_PACKET_CANCEL = '/packetsSubscription/cancelPacket/:uuid';
export const POST_PACKET_RENEW = '/packetsSubscription/restorePacket/:uuid';
export const POST_RETRY_LAST_PAYMENT = '/packetsSubscription/retryPayment';

export const SUBSCRIBER_DETAILS_QUERY_KEY = 'fetch_subscriber_details';
export const QUERY_PROFILE_PACKETS = 'fetch_subscriber_packets_agreements';
